import { createAtomObserver } from '@exodus/atoms';
const createOrdersPlugin = ({ orders, port, ordersAtom, ordersMonitor, }) => {
    const atomObserver = createAtomObserver({
        atom: ordersAtom,
        port,
        event: 'orders',
    });
    const onLoad = () => {
        atomObserver.start();
    };
    const onLock = () => {
        orders.stop();
    };
    const onUnlock = () => {
        orders.load();
        ordersMonitor.tick();
    };
    const onClear = () => {
        orders.stop();
        return ordersAtom.set(undefined);
    };
    const onStop = () => orders.stop();
    return { onClear, onLoad, onStop, onLock, onUnlock };
};
const ordersPluginDefinition = {
    id: 'ordersLifecyclePlugin',
    type: 'plugin',
    factory: createOrdersPlugin,
    dependencies: ['orders', 'port', 'ordersAtom', 'ordersMonitor'],
    override: true,
};
export default ordersPluginDefinition;
